import { render, staticRenderFns } from "./BackgroundPicker.vue?vue&type=template&id=842a9916&scoped=true"
import script from "./BackgroundPicker.vue?vue&type=script&lang=js"
export * from "./BackgroundPicker.vue?vue&type=script&lang=js"
import style0 from "./BackgroundPicker.vue?vue&type=style&index=0&id=842a9916&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842a9916",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('842a9916')) {
      api.createRecord('842a9916', component.options)
    } else {
      api.reload('842a9916', component.options)
    }
    module.hot.accept("./BackgroundPicker.vue?vue&type=template&id=842a9916&scoped=true", function () {
      api.rerender('842a9916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/display-builder/BackgroundPicker.vue"
export default component.exports